import {gql} from "@apollo/client";

export const REMOVE_REWARDMAPPING = gql`
    mutation removeRewardMapping($id: String!) {
      removeRewardMapping(id: $id)
    }
`;